import { AnalyticsConfig } from "@/app/[locale]/_components/analytics";
import { isTrackingEnabled } from "@/lib/analytics/tracking-gate";

const GA_MEASUREMENT_ID = AnalyticsConfig.googleAnalytics.trackingId;

export const sendGAEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (!isTrackingEnabled()) {
    return;
  }

  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, {
      ...eventParams,
      send_to: GA_MEASUREMENT_ID,
    });
  }
};

export const trackAudioPlayer = (action: "play" | "pause" | "skip_forward" | "skip_backward", audioUrl: string) => {
  sendGAEvent("audio_player_interaction", {
    action,
    audio_url: audioUrl,
    timestamp: new Date().toISOString(),
  });
};

export const trackPopupDisplay = (popupType: "exit_intent" | "newsletter_scroll") => {
  sendGAEvent("popup_displayed", {
    popup_type: popupType,
    timestamp: new Date().toISOString(),
  });
};

export const trackPopupClick = (
  popupType: "exit_intent" | "newsletter_scroll",
  action: "close" | "cta_click" | "newsletter_submit",
) => {
  sendGAEvent("popup_interaction", {
    popup_type: popupType,
    action,
    timestamp: new Date().toISOString(),
  });
};

export const trackScrollDepth = (percentage: 25 | 50 | 75 | 100, articleSlug?: string) => {
  sendGAEvent("scroll_depth", {
    scroll_percentage: percentage,
    article_slug: articleSlug,
    timestamp: new Date().toISOString(),
  });
};
